import { FC } from 'react';
import Layout from '@layout/index';
import { UNACADEMY_AI_PAGE } from '@cont/DoubtsUnacademyAI/constants';
import { fetchGoalInfo } from '@api/fetchers/goal';
import UnacademyAIContainer from '@cont/DoubtsUnacademyAI/UnacademyAI';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';
import { DoubtsAIContextProvider } from '@context/DoubtsAIContext';

type FallbackData = { goalInfo: Record<string, any> };
interface IUnacademyAIProps {
  fallbackData: FallbackData;
}

const UnacademyAI: FC<IUnacademyAIProps> = ({ fallbackData }) => {
  const { uid: goalUID, slug: goalSlug } = fallbackData.goalInfo || {};

  return (
    <DoubtsAIContextProvider>
      <UnacademyAIContainer goalUID={goalUID} goalSlug={goalSlug} />
    </DoubtsAIContextProvider>
  );
};

// @ts-ignore
UnacademyAI.pageInfo = {
  name: UNACADEMY_AI_PAGE,
  layoutOptions: {
    hideFooter: true,
    noMobilePadding: true,
    hideIntercom: true,
    hideFreshbot: true,
    hideHeaderOnMobile: true
  },
  isMWebSupported: true
};

export const getStaticProps = async ({ params }) => {
  const { goalSlug, goalUID } = params;
  try {
    const goal = await fetchGoalInfo(goalUID);
    if (!goal || goal.errorCode) return { notFound: true, revalidate: 5 };

    const fallbackData: FallbackData = {
      goalInfo: goal
    };
    return {
      props: {
        goalUID,
        goalSlug,
        fallbackData
      },
      // TODO : Finalize on the revalidate time
      revalidate: 5
    };
  } catch (error) {
    return { notFound: true, revalidate: 5 };
  }
};

export const getStaticPaths = async () => {
  return {
    paths: [],
    fallback: 'blocking'
  };
};

// @ts-ignore
UnacademyAI.propTypes = {};
// @ts-ignore
UnacademyAI.Layout = Layout;
// @ts-ignore
UnacademyAI.Wrapper = PageReduxProvider;

export default UnacademyAI;
